import client from './client';

const getMachinesByUser = (datas) => client.get("/getMachinesByUser");

export default
{ 
    getMachinesByUser
}